module.exports = __webpack_public_path__ + "static/media/jokes.c85b3d3c.png";